const state = {
    searches: []
}

const getters = {
    getFavoriteSearches: (state) => {
        return state.searches
    }
}

const mutations = {
    pushToFavoriteSearches: (state, newValue) => {
        state.searches.push(newValue)
    },
    updateFavoriteSearches: (state, newValue) => {
        state.searches = newValue
    },


}

const actions = {
    addToFavoriteSearches: ({ commit }, newValue) => {
        commit('pushToFavoriteSearches', newValue)
    },
    setFavoriteSearches: ({ commit }, newValue) => {
        commit('updateFavoriteSearches', newValue)
    },
}

export default { state, getters, mutations, actions }


// WEBPACK FOOTER //
// ./src/store/modules/favoriteSearches.js